export default __webpack_public_path__ + "static/media/emotion-xl.26e1635c.png";